"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapshotResourceType = void 0;
var SnapshotResourceType;
(function (SnapshotResourceType) {
    SnapshotResourceType["ScriptURL"] = "ScriptURL";
    SnapshotResourceType["ScriptCode"] = "ScriptCode";
    SnapshotResourceType["AMDScriptURL"] = "AMDScriptURL";
    SnapshotResourceType["AMDScriptCode"] = "AMDScriptCode";
})(SnapshotResourceType = exports.SnapshotResourceType || (exports.SnapshotResourceType = {}));
//# sourceMappingURL=snapshotManager.js.map